import Joi from 'joi-browser'
import moment from 'moment'
import React, { Component } from 'react'
import Form from '../../common/form/form'
import SelectSearchAsync from '../../common/form/selectSearchAsync'
import SelectSearch from '../../common/form/selectSearch'
import Select from 'react-select'

import SubmitBtn from '../../common/form/submitBtn'
import { getPatient, patientSearch, patientSearchForStaff } from '../../../store/patient'
import Header from './header'
import LeftBar from './leftBar'
import dayjs from 'dayjs';
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { createOrderByDoctor, createOrderByStaff, getAppointment } from '../../../store/appointment'
import { toast } from 'react-toastify'
import AlertSuccess from '../../common/alertSuccess'
import AlertError from '../../common/alertError'
import StaffleftBar from './staffleftBar'
import { getStaffToken } from '../../services/localStorageServices'
import { getDoctor } from '../../../store/doctor'
class RecordVisit extends Form {
  state = {
    loader: false,
    btnClass: 'btn btn-primary btn-lg',
    data: { 
      type: {},
      patient: '', 
      date: new Date(), 
      duration: '', 
      time: '', 
      fee: '', 
      clinicType: null,
    },
    errors: {},
    sidebarToogle: false,
  }

  toggleSidebar = () => {
    this.setState({ sidebarToogle: !this.state.sidebarToogle })
  }
  getTimeStops = (start, end) => {
    var startTime = moment(start, 'HH:mm')
    var endTime = moment(end, 'HH:mm')

    if (endTime.isBefore(startTime)) {
      endTime.add(1, 'day')
    }

    var timeStops = []

    while (startTime <= endTime) {
      timeStops.push({
        name: new moment(startTime).format('hh:mm A'),
        value: new moment(startTime).format('HH:mm'),
      })
      startTime.add(15, 'minutes')
    }
    return timeStops
  }
  schema = {
    patient: Joi.object()
      .required()
      .error(errors => {
        errors.forEach(err => {
          switch (err.type) {
            case 'object.base':
              err.message = 'Patient Required'
              break
          }
        })
        return errors
      }),
    date: Joi.date()
      .required()
      .error(errors => {
        errors.forEach(err => {
          switch (err.type) {
            case 'date.base':
              err.message = 'Date required'
              break
          }
        })
        return errors
      }),

    time: Joi.object().error(errors => {
      errors.forEach(err => {
        switch (err.type) {
          case 'object.base':
            err.message = 'Time required'
            break
        }
      })
      return errors
    }),
    duration: Joi.object()
      .required()
      .error(errors => {
        errors.forEach(err => {
          switch (err.type) {
            case 'object.base':
              err.message = 'Duration Required'
              break
          }
        })
        return errors
      }),
    type: Joi.object()
      .required()
      .error(errors => {
        errors.forEach(err => {
          switch (err.type) {
            case 'object.base':
              err.message = 'Type Required'
              break
          }
        })
        return errors
      }),
    fee: Joi.number().error(errors => {
      errors.forEach(err => {
        switch (err.type) {
          case 'number.base':
            err.message = 'Fee required'
            break
        }
      })
      return errors
    }),
    clinicType: Joi.when('type.value', {
      is: Joi.valid('clinic', 'walkin'),
      then: Joi.object()
        .required()
        .error(errors => {
          errors.forEach(err => {
            switch (err.type) {
              case 'any.required':
              case 'object.base':
                err.message = 'Clinic Type required';
                break;
            }
          });
          return errors;
        }),
      otherwise: Joi.optional().allow(null, ''),
    }),
  }
  componentDidMount() {
    document.body.classList.remove('p-0')
    document.body.classList.add(
      this.props.history.location.pathname !== '/staff/recordVisit'
        ? 'dashboard'
        : 'dashboard-staff'
    )
    if(getStaffToken("auth")){
    this.props.patientSearchForStaff({ sort_by: 'created_on', sort: 'desc' })
    } else {
    this.props.patientSearch({ sort_by: 'created_on', sort: 'desc' })
    }
  }

  updateData = data => {
    this.setState({ data })
    console.log(data)
  }

  loadOptions = inputValue => {
    if(getStaffToken("auth")){
    this.props.patientSearchForStaff({
      search: inputValue,
      sort_by: 'created_on',
      sort: 'desc',
    })      
    } else {
    this.props.patientSearch({
      search: inputValue,
      sort_by: 'created_on',
      sort: 'desc',
    })
    }
    // console.log(inputValue)
  }
  updateStep = step => this.setState({ step })

  onChange = res => {
    const patient = res.currentTarget
    const { data, errors } = this.state
    data.patient = patient
    errors.patient = ''
    this.setState({ data, errors })
  }

  onChangeTime = res => {
    const time = res.currentTarget
    // console.log(time)
    const { data, errors } = this.state
    data.time = time
    errors.time = ''
    this.setState({ data, errors })
  }
  onChangeDuration = res => {
    const duration = res.currentTarget
    const { data, errors } = this.state
    data.duration = duration
    errors.duration = ''
    this.setState({ data, errors })
  }
  doSubmit = () => {
    const { patient, date, time, fee, type, duration, clinicType } = this.state.data
    const timeArr = time.value.split(':')
    const dateTime = moment(date)
    const payload = {
      patient_id: patient.value,
      appointment_time: dateTime.format(
        'YYYY-MM-DD[T' + timeArr[0] + ':' + timeArr[1] + ':00.000Z]'
      ),
      fees: fee,
      duration: duration.value,
      type: type.value,
    }
    if (type.value === "clinic") {
      payload.clinic_type = Number(clinicType.value)
    }
    if (!this.state.loader) {
      this.setState({
        btnClass: 'btn btn-primary btn-lg disabled',
        loader: true,
      })
      if(getStaffToken("auth")){
        this.props.createOrderByStaff(payload, this.callBack)
      } else {
        this.props.createOrderByDoctor(payload, this.callBack)
      }
    }
  }

  callBack = res => {
    this.setState({
      btnClass: 'btn btn-primary btn-lg',
      loader: false,
    })
    if (res && res.status === 200) {
      toast(<AlertSuccess message={'Infomation saved.'} />)
      this.props.history.goBack()
    } else {
      toast(<AlertError message={'Something went wrong.'} />)
    }
  }
  onChangeType = res => {
    const type = res.currentTarget
    const { data, errors } = this.state
    data.type = type
    errors.type = ''
    this.setState({ data, errors })
  }

  onChangeClinicType = selected => {
    const { data, errors } = this.state
    data.clinicType = selected
    errors.clinicType = ''
    this.setState({ data, errors })
  }

  customStyles = {
    indicatorSeparator: styles => ({ display: 'none' }),
    option: (provided, state) => ({
      ...provided,
      '&:hover': {
        backgroundColor: 'rgb(95, 50, 187, 10%)',
        color: '#621ac0',
      },

      'color': state.isSelected ? '#621ac0' : 'black',
      'backgroundColor': state.isSelected
        ? 'rgb(95, 50, 187, 10%)'
        : provided.backgroundColor,
    }),
    control: (base, state) => ({
      ...base,
      'height': 55,
      'minHeight': 55,
      'borderColor': state.isFocused ? '#6119c0' : '#e0e0e0',
      'boxShadow': '0 !important',
      '&:hover': {
        borderColor: '#6119c0',
      },
      '&:focus': {
        borderColor: '#6119c0',
      },
    }),
    multiValueRemove: (base, state) => ({
      ...base,
      '&:hover': {
        backgroundColor: 'rgb(95, 50, 187, 10%)',
        color: '#6119c0',
      },
    }),
  }

  render() {
    const doctor = this.props.doctorProfile
    const times = this.getTimeStops('00:00', '23:45')
    const patients = this.props.patients
    const options = patients.map(e => ({
      value: e._id,
      name: e.first_name + ' ' + e.last_name + ' ('+ (e.mobileCode || '') + ' ' + e.mobile + ')',
      type: e.type,
    }))

    const clinicOptions = [
      doctor?.clinic_details?.name && {
        name: `${doctor.clinic_details.name} (Clinic 1)`,
        value: 1,
      },
      doctor?.clinic_details_2?.name && {
        name: `${doctor.clinic_details_2.name} (Clinic 2)`,
        value: 2,
      }
    ].filter(Boolean);

    const schedule = this.props.doctorProfile?.schedules;
    const time  = schedule?.time;
    const time2 = schedule?.time2;

    const durations = [time, time2].filter(Boolean);
    return (
      <div className={this.state.sidebarToogle ? 'dashboard on' : 'dashboard'}>
        {/* {this.props.history.location.pathname !== '/staff/recordVisit' && (
          <LeftBar />
        )} */}
        {this.props.history.location.pathname !== '/staff/recordVisit' ? 
          <LeftBar /> : <StaffleftBar/>
        }
        <Header
          sidebarToogle={this.state.sidebarToogle}
          toggleSidebar={this.toggleSidebar}
        />
        <div className='dashboard-main-container'>
          <div className='dashboard-content-box'>
            <h4>Record Visit</h4>
            <form onSubmit={this.handleSubmit}>
              <div className='dc-body d-flex flex-wrap align-items-lg-center'>
                <div className='dc-left'>
                  <h4 className='d-block d-xl-none'>Personal Details</h4>
                  <div className='dc-form-box'>
                    <div className='row'>
                      <div className='col-md-12'>
                        <SelectSearchAsync
                          name='patient'
                          options={options}
                          label='Patient'
                          error={this.state.errors.patient}
                          value={this.state.data.patient}
                          onChange={this.onChange}
                          loadOptions={this.loadOptions}
                          showPatientIcons
                        />
                      </div>
                    </div>

                    {this.state.data.patient && (
                      <>
                        <div className='row'>
                          <div className='col-md-6'>
                            {this.renderDateInput('date', 'Appointment Date', null, null, false, null, dayjs())}
                          </div>
                          <div className='col-md-6'>
                            <SelectSearch
                              name='duration'
                                options={durations.map(duration => ({
                                  name: `${duration} Mins`,
                                  value: duration
                                }))}
                              label='Duration'
                              error={this.state.errors.time}
                              value={this.state.data.duration}
                              onChange={this.onChangeDuration}
                            />
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-md-6'>
                            <SelectSearch
                              name='time'
                              options={times}
                              label='Time'
                              error={this.state.errors.time}
                              value={this.state.data.time}
                              onChange={this.onChangeTime}
                            />
                          </div>
                          <div className='col-md-6'>
                            {this.renderInput('fee', 'Fees', 'number')}
                          </div>
                        </div>
                        <div className="row">
                          <div className='col-md-6'>
                            <SelectSearch
                              name='Type'
                              options={[
                                { name: 'online', value: 'online' },
                                { name: 'clinic', value: 'clinic' },
                              ]}
                              label='Type'
                              error={this.state.errors.type}
                              value={this.state.data.type.value}
                              onChange={this.onChangeType}
                            />
                          </div>
                          <div className="col-md-6">
                            <Select
                              styles={this.customStyles}
                              placeholder="Select Clinic"
                              options={clinicOptions.map(c => ({
                                label: c.name,
                                value: c.value,
                              }))}
                              value={this.state.data.clinicType}
                              isDisabled={
                                this.state.data.type?.value !== 'clinic' &&
                                this.state.data.type?.value !== 'walkin'
                              }
                              onChange={this.onChangeClinicType}
                            />
                            {this.state.errors.clinicType && (
                              <div class="form-group custom-input">
                                <label className="error">
                                  {this.state.errors.clinicType}
                                </label>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className='prescription-btn d-flex justify-content-between align-items-center'>
                <a
                  class='btn btn-outline no-shadow'
                  onClick={() => this.props.history.goBack()}>
                  Back
                </a>
                <SubmitBtn
                  label='Save'
                  loading={this.state.loading}
                  btnClass={this.state.btnClass}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  patientSearch: param => dispatch(patientSearch(param)),
  patientSearchForStaff: param => dispatch(patientSearchForStaff(param)),
  createOrderByDoctor: (param, callback) =>
    dispatch(createOrderByDoctor(param, callback)),
  createOrderByStaff: (param, callback) =>
    dispatch(createOrderByStaff(param, callback)),
})
const mapStateToProps = state => ({
  patients: getPatient(state).patientList,
  doctorProfile: getDoctor(state).profile,
  getAppointment: getAppointment(state),
})
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RecordVisit)
)
